import React, { useContext, useEffect, useState } from "react";
import { Card, CircularProgress, Container, } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useMutation } from "@tanstack/react-query";
import { ToastContext } from "../../contexts/toast-context.jsx";
import { OkDialog } from "../ui/ok-dialog.jsx";
import { verifyEmail } from "../../api/email-verification-api.js";
import { AuthContext } from "../../contexts/auth-context.jsx";

export function VerifyEmail() {
  const { t } = useTranslation(["auth", "validation", "common"]);
  const { showError } = useContext(ToastContext);
  const { loginByToken } = useContext(AuthContext);
  const [showSuccess, setShowSuccess] = useState(false);
  const navigate = useNavigate();
  const [tokenRes, setTokenRes] = useState(null);
  const handleCloseSuccessDialog = () => {
    loginByToken(tokenRes)
  }

  const [searchParams] = useSearchParams();

  const mutation = useMutation({
    mutationFn: () => {
      return verifyEmail(searchParams.get("token"))
    },
    onSuccess: (res) => {
      setShowSuccess(true);
      setTokenRes(res);
    },
    onError: (error) => {
      if (error.response?.data?.error === "email_verified") {
        showError(t("emailAlreadyVerified"));
      } else {
        const errorMessage = error.response?.data?.error_message || t("verifyEmailError");
        showError(errorMessage);
      }
      navigate("/login");
    }
  });
  useEffect(() => {
    if (!searchParams.has("token")) {
      navigate("/login");
    } else {
      mutation.mutate();
    }
  }, [searchParams]);

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card
        sx={{
          px: 5,
          py: 3,
          width: "400px",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          margin: "auto",
        }}
      >
        <CircularProgress size={30}/>
        <OkDialog
          open={showSuccess}
          onClose={handleCloseSuccessDialog}
          text={t("verifyEmailSuccess")}
          buttonText={t("ok")}
        />
      </Card>
    </Container>
  );
}
